import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { MongoResource } from '../../shared/mongo.resource';
import { INotification } from './notifications.model';


@Injectable()
export class NotificationsService extends MongoResource<any, INotification, INotification> {

  baseUrl = environment.api + 'notifications';
  constructor(public http: HttpClient) { super(http); }
}



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/shared/notifications.service.ts